(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["carnatia-gifting"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('carnatia-gift-card')){
 customElements.define('carnatia-gift-card',class extends HTMLElement{
  connectedCallback(){
   this.abort?.abort();this.abort=new AbortController();const options={signal:this.abort.signal};
   const rail=this.querySelector('.cg-card__slides');const slides=[...rail.children];
   const move=index=>rail.scrollTo({left:index*rail.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
   this.querySelectorAll('[data-step]').forEach(button=>{button.hidden=false;button.addEventListener('click',()=>{const index=Math.round(rail.scrollLeft/rail.clientWidth);move((index+Number(button.dataset.step)+slides.length)%slides.length)},options)});
   rail.addEventListener('keydown',event=>{if(event.target!==rail||!['ArrowLeft','ArrowRight'].includes(event.key))return;event.preventDefault();const index=Math.round(rail.scrollLeft/rail.clientWidth);move(Math.max(0,Math.min(slides.length-1,index+(event.key==='ArrowRight'?1:-1))))},options);
   rail.addEventListener('scroll',()=>{const counter=this.querySelector('.cg-card__counter');if(counter)counter.textContent=`${Math.round(rail.scrollLeft/rail.clientWidth)+1} / ${slides.length}`},{...options,passive:true});
   const select=this.querySelector('select[name="id"]');
   select?.addEventListener('change',()=>{
    const option=select.selectedOptions[0];const available=option.dataset.available==='true';
    this.querySelectorAll('[data-price-id]').forEach(price=>price.hidden=price.dataset.priceId!==select.value);
    this.querySelectorAll('.cg-card__button').forEach(button=>button.disabled=!available);
    this.querySelector('.cg-card__button--add').textContent=available?'Add to cart':'Sold out';
    const imageIndex=slides.findIndex(slide=>slide.dataset.imageId===option.dataset.image);if(imageIndex>=0)move(imageIndex);
   },options);
  }
  disconnectedCallback(){this.abort?.abort()}
 });
}

if(!customElements.get('carnatia-gift-carousel')){
 customElements.define('carnatia-gift-carousel',class extends HTMLElement{
  connectedCallback(){
   this.abort?.abort();this.abort=new AbortController();const opts={signal:this.abort.signal};
   const rail=this.querySelector('.cg-products__grid'),controls=this.querySelector('.cg-carousel__controls'),buttons=[...controls.querySelectorAll('button')];
   const update=()=>{const max=rail.scrollWidth-rail.clientWidth;controls.hidden=max<2;buttons[0].disabled=rail.scrollLeft<=2;buttons[1].disabled=rail.scrollLeft>=max-2};
   const move=direction=>{const card=rail.querySelector('.cg-card');if(card)rail.scrollBy({left:direction*(card.getBoundingClientRect().width+16),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'})};
   buttons.forEach(button=>button.addEventListener('click',()=>move(Number(button.dataset.slide)),opts));
   rail.addEventListener('scroll',update,{...opts,passive:true});
   rail.addEventListener('keydown',event=>{if(event.target!==rail)return;if(['ArrowLeft','ArrowRight'].includes(event.key)){event.preventDefault();move(event.key==='ArrowRight'?1:-1)}},opts);
   this.observer=new ResizeObserver(update);this.observer.observe(rail);update();
  }
  disconnectedCallback(){this.abort?.abort();this.observer?.disconnect()}
 });
}


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carnatia-product-cards-home"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('carnatia-product-card')){
 customElements.define('carnatia-product-card',class extends HTMLElement{
  connectedCallback(){
   this.abort?.abort();this.abort=new AbortController();const options={signal:this.abort.signal};
   const rail=this.querySelector('.cn-card__slides');const slides=[...rail.children];
   const move=index=>rail.scrollTo({left:index*rail.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
   this.querySelectorAll('[data-step]').forEach(button=>{button.hidden=false;button.addEventListener('click',()=>{const index=Math.round(rail.scrollLeft/rail.clientWidth);move((index+Number(button.dataset.step)+slides.length)%slides.length)},options)});
   rail.addEventListener('keydown',event=>{if(event.target!==rail||!['ArrowLeft','ArrowRight'].includes(event.key))return;event.preventDefault();const index=Math.round(rail.scrollLeft/rail.clientWidth);move(Math.max(0,Math.min(slides.length-1,index+(event.key==='ArrowRight'?1:-1))))},options);
   rail.addEventListener('scroll',()=>{const counter=this.querySelector('.cn-card__counter');if(counter)counter.textContent=`${Math.round(rail.scrollLeft/rail.clientWidth)+1} / ${slides.length}`},{...options,passive:true});
   const select=this.querySelector('select[name="id"]');
   select?.addEventListener('change',()=>{
    const option=select.selectedOptions[0];const available=option.dataset.available==='true';
    this.querySelectorAll('[data-price-id]').forEach(price=>price.hidden=price.dataset.priceId!==select.value);
    this.querySelectorAll('.cn-card__button').forEach(button=>button.disabled=!available);
    this.querySelector('.cn-card__button--add').textContent=available?'Add to cart':'Sold out';
    const imageIndex=slides.findIndex(slide=>slide.dataset.imageId===option.dataset.image);if(imageIndex>=0)move(imageIndex);
   },options);
  }
  disconnectedCallback(){this.abort?.abort()}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["carnatia-rituals"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('carnatia-care')){customElements.define('carnatia-care',class extends HTMLElement{
 connectedCallback(){
  this.abort?.abort();this.abort=new AbortController();const opts={signal:this.abort.signal};
  const tabs=[...this.querySelectorAll('[role=tab]')],panels=[...this.querySelectorAll('[data-panel]')];
  const select=index=>{tabs.forEach((tab,i)=>{tab.setAttribute('aria-selected',String(i===index));tab.tabIndex=i===index?0:-1;panels[i].hidden=i!==index})};
  tabs.forEach((tab,index)=>{tab.addEventListener('click',()=>select(index),opts);tab.addEventListener('keydown',event=>{let next=index;if(event.key==='ArrowRight')next=(index+1)%tabs.length;else if(event.key==='ArrowLeft')next=(index-1+tabs.length)%tabs.length;else if(event.key==='Home')next=0;else if(event.key==='End')next=tabs.length-1;else return;event.preventDefault();select(next);tabs[next].focus()},opts)});
  panels.forEach(panel=>{
   const tips=[...panel.querySelectorAll('[data-tip]')],steps=[...panel.querySelectorAll('[data-step]')];let current=0;
   const change=index=>{current=index;tips.forEach((tip,i)=>tip.hidden=i!==index);steps.forEach((button,i)=>button.setAttribute('aria-pressed',String(i===index)));panel.querySelector('.care-progress').textContent=`${index+1} of 3`;panel.querySelector('.care-next').innerHTML=index===2?'Start again <span aria-hidden="true">↺</span>':'Next tip <span aria-hidden="true">→</span>'};
   steps.forEach((button,index)=>button.addEventListener('click',()=>change(index),opts));
   panel.querySelector('.care-next').addEventListener('click',()=>change((current+1)%3),opts);
   panel.querySelector('.care-steps').hidden=false;panel.querySelector('.care-next').hidden=false;
   panel.setAttribute('role','tabpanel');panel.setAttribute('aria-labelledby',tabs[panels.indexOf(panel)].id);change(0);
  });
  this.querySelector('.care-tabs').hidden=false;this.setAttribute('data-ready','');select(0);
  document.addEventListener('shopify:block:select',event=>{const panel=event.target.closest('[data-panel]');if(panel&&this.contains(panel))select(panels.indexOf(panel))},opts);
 }
 disconnectedCallback(){this.abort?.abort()}
})}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["category-carousel"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('carnatia-categories')){
 customElements.define('carnatia-categories',class extends HTMLElement{
  connectedCallback(){
   this.abort?.abort();this.abort=new AbortController();const opts={signal:this.abort.signal};
   const wrapper=this.closest('.shopify-section')||this.parentElement;
   this.visibility=new IntersectionObserver(entries=>wrapper.classList.toggle('cc-motion-paused',!entries[0].isIntersecting));this.visibility.observe(this);
   const rail=this.querySelector('.cc-track'),controls=this.querySelector('.cc-controls');
   const buttons=[...this.querySelectorAll('.cc-arrow')];
   const update=()=>{const max=rail.scrollWidth-rail.clientWidth;controls.hidden=max<2;buttons[0].disabled=rail.scrollLeft<=2;buttons[1].disabled=rail.scrollLeft>=max-2};
   const step=()=>{const item=rail.querySelector('.cc-item');return item?item.getBoundingClientRect().width+parseFloat(getComputedStyle(rail).gap):rail.clientWidth};
   const move=direction=>rail.scrollBy({left:direction*step(),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
   buttons.forEach(button=>button.addEventListener('click',()=>move(Number(button.dataset.direction)),opts));
   rail.addEventListener('scroll',update,{...opts,passive:true});
   rail.addEventListener('keydown',event=>{if(event.target!==rail)return;if(event.key==='ArrowRight'||event.key==='ArrowLeft'){event.preventDefault();move(event.key==='ArrowRight'?1:-1)}},opts);
   document.addEventListener('shopify:block:select',event=>{const item=event.target.closest('.cc-item');if(item&&this.contains(item))rail.scrollTo({left:item.getBoundingClientRect().left-rail.getBoundingClientRect().left+rail.scrollLeft,behavior:'instant'})},opts);
   this.observer=new ResizeObserver(update);this.observer.observe(rail);update();
  }
  disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();this.visibility?.disconnect()}
 });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom-marquee"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('carnatia-marquee')) {
    customElements.define('carnatia-marquee', class extends HTMLElement {
      connectedCallback() {
        this.viewport = this.querySelector('.carnatia-marquee__viewport');
        this.track = this.querySelector('.carnatia-marquee__track');
        this.original = this.querySelector('[data-original]');
        this.button = this.querySelector('button');
        if (!this.original) return;
        this.onToggle = () => {
          const paused = this.toggleAttribute('data-paused');
          this.button.setAttribute('aria-pressed', String(paused));
          this.button.setAttribute('aria-label', paused ? 'Resume announcements' : 'Pause announcements');
          this.button.querySelector('[data-play]').hidden = !paused;
          this.button.querySelector('[data-pause]').hidden = paused;
        };
        this.button.addEventListener('click', this.onToggle);
        this.onResize = () => {
          cancelAnimationFrame(this.frame);
          this.frame = requestAnimationFrame(() => this.build());
        };
        this.observer = new ResizeObserver(this.onResize);
        this.observer.observe(this.viewport);
        this.media = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.media.addEventListener('change', this.onResize);
        document.fonts.ready.then(() => { if (this.isConnected) this.onResize(); });
        this.build();
      }
      cleanCopy(node) {
        node.setAttribute('data-copy', '');
        node.setAttribute('aria-hidden', 'true');
        node.removeAttribute('data-original');
        [node, ...node.querySelectorAll('*')].forEach(el => {
          el.removeAttribute('id');
          [...el.attributes].forEach(attr => {
            if (attr.name.startsWith('data-shopify')) el.removeAttribute(attr.name);
          });
        });
        return node;
      }
      build() {
        this.track.querySelectorAll('[data-copy]').forEach(el => el.remove());
        this.removeAttribute('data-ready');
        this.button.hidden = true;
        if (this.media.matches || this.viewport.clientWidth === 0) return;
        this.setAttribute('data-ready', '');
        this.button.hidden = false;
        const items = [...this.original.children];
        const initialWidth = this.original.getBoundingClientRect().width;
        if (!initialWidth) { this.removeAttribute('data-ready'); this.button.hidden = true; return; }
        const repetitions = Math.ceil(this.viewport.clientWidth / initialWidth);
        for (let i = 1; i < repetitions; i++) {
          items.forEach(item => this.original.appendChild(this.cleanCopy(item.cloneNode(true))));
        }
        const width = this.original.getBoundingClientRect().width;
        this.style.setProperty('--cm-duration', `${width / (Number(this.dataset.speed) || 40)}s`);
        this.track.appendChild(this.cleanCopy(this.original.cloneNode(true)));
      }
      disconnectedCallback() {
        this.observer?.disconnect();
        cancelAnimationFrame(this.frame);
        this.media?.removeEventListener('change', this.onResize);
        this.button?.removeEventListener('click', this.onToggle);
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
